import workshopPlaylist from './workshop';
import foundationPlaylist from './foundation';
import minimalWavePlaylist from './minimal-wave';
import ppuPlaylist from './ppu';
import soundwayPlaylist from './soundway';
import stonesThrowPlaylist from './stones-throw';
import burgerPlaylist from './burger';
import golfChannelPlaylist from './golf-channel';
import rockersPlaylist from './rockers';
import plantPlaylist from './plant';


export default {
  workshop: workshopPlaylist,
  foundation: foundationPlaylist,
  'minimal-wave': minimalWavePlaylist,
  ppu: ppuPlaylist,
  plant: plantPlaylist,
  soundway: soundwayPlaylist,
  'stones-throw': stonesThrowPlaylist,
  'burger': burgerPlaylist,
  'golf-channel': golfChannelPlaylist,
  'rockers': rockersPlaylist
};


/** WEBPACK FOOTER **
 ** ./src/playlists/index.es6
 **/